<template>
  <div @mouseleave="params.colDef.CellRendererParams.leavingMouse(params.data)">
    <ul class="flex" v-if="!params.data.attendance_marked">
      <li class="mr-2" v-if="params.colDef.CellRendererParams.isStudentList ? params.colDef.CellRendererParams.checkMarkAttendanceModule() : true">
        <vs-radio
          v-model="params.data.attendance"
          :vs-name="`attendance${params.rowIndex}`"
          :vs-value="true"
          :disabled="checkCurrentDay"
          @change="params.colDef.CellRendererParams.markingAttendance(true, params.data)"
        >
          Present</vs-radio
        >
        <vs-input
          v-if="params.data.attendance"
          style="width: 100px"
          type="number"
          placeholder="Delayed by"
          min="1"
          max="120"
          v-model="params.data.delay_in_minutes"
          @keyup.enter="
            params.colDef.CellRendererParams.markingAttendance(
              true,
              params.data,
              'delayed',
              $event
            )
          "
        />
      </li>
      <li class="mr-2" v-if="params.colDef.CellRendererParams.isStudentList ? params.colDef.CellRendererParams.checkMarkAttendanceModule() : true">
        <vs-radio
          v-model="params.data.attendance"
          :vs-name="`attendance${params.rowIndex}`"
          :vs-value="false"
          :disabled="checkCurrentDay"
          @change="params.colDef.CellRendererParams.markingAttendance(false, params.data)"
          >Absent</vs-radio
        >
      </li>
    </ul>
    <div v-else class="flex items-center">
      <span
        class="attendance-badge"
        :class="params.data.attendance ? 'present' : 'absent'"
      >
        {{ params.data.attendance ? "Present" : "Absent" }}
      </span>
      <a
        v-if="params.colDef.CellRendererParams.isStudentList ? params.colDef.CellRendererParams.checkMarkAttendanceModule() : true"
        class="material-icons edit_att"
        @click="params.colDef.CellRendererParams.editAttendance(params.data)"
        >edit</a
      >
    </div>
    <!-- {{params.data.delay_in_minutes}} -->
    <small
      v-if="
        params.data.delay_in_minutes &&
        params.data.attendance_marked &&
        params.data.attendance
      "
      style="color: gray; font-weight: 600"
      >Delayed by: {{ params.data.delay_in_minutes }} mins</small
    >
  </div>
</template>

<script>
export default {
  name: 'AttendanceCell',
  computed :{
    checkCurrentDay () {
      return !(this.$moment().diff(this.params.data.schedule_date+" "+this.params.data.schedule_from_time, 'minutes') >= 0)
    }
  },
}
</script>